<div class="template-form">
  @if (isStep1) {
    <app-record-template-step1></app-record-template-step1>
  } @else {
    <app-record-template-step2></app-record-template-step2>
  }
</div>
